import React from "react";
import { altColor } from "../../utils/constants";

export default function ClickArrowIcon({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="154.15" height="154.15" viewBox="0 0 154.15 154.15">
      <g id="up-arrow" transform="translate(154.15) rotate(90)">
        <g id="Gruppe_37" data-name="Gruppe 37">
          <g id="Gruppe_36" data-name="Gruppe 36">
            <path
              id="Pfad_205"
              data-name="Pfad 205"
              d="M77.075,0A77.075,77.075,0,1,0,154.15,77.075,77.159,77.159,0,0,0,77.075,0Zm0,142.21A65.135,65.135,0,1,1,142.21,77.075,65.211,65.211,0,0,1,77.075,142.21Z"
              fill={color}
            />
          </g>
        </g>
        <g id="Gruppe_39" data-name="Gruppe 39" transform="translate(41.608 53.726)">
          <g id="Gruppe_38" data-name="Gruppe 38">
            <path
              id="Pfad_206"
              data-name="Pfad 206"
              d="M207.754,210.035,177.9,180.184a5.967,5.967,0,0,0-8.418,0l-29.851,29.851a5.97,5.97,0,0,0,8.418,8.418l25.612-25.612,25.672,25.612a5.952,5.952,0,0,0,8.418-8.418Z"
              transform="translate(-138.197 -178.447)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
